import { connect } from 'react-redux';

import LoadingDashboardValue from '../../../../multiLoanDashboard/dashboardComponents/loadingDashboardValue/LoadingDashboardValue';

const mapStateToProps = (state) => ({
    isLoading: state.api.rbl_estimated_schedule.pending
});

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(LoadingDashboardValue);
